/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_Instruction_2Inputs */



/**
* | output |
* | --- |
* | "Never share this code with anyone" |
*
* @param {Auth_Recovery_Code_Instruction_2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_instruction_2 = /** @type {((inputs?: Auth_Recovery_Code_Instruction_2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_Instruction_2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teile diesen Code niemals mit jemandem")
	return /** @type {LocalizedString} */ ("Never share this code with anyone")
});